module.exports = __webpack_public_path__ + "img/mx.4fb7c48f.svg";